import ShoppingCartOutlined from '@mui/icons-material/ShoppingCartOutlined';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import { Link as RouterLink } from 'react-router';

import { useAccessoryOrderStore } from '@/stores/accessoryOrderStore';

/** Header link to the accessory order list. Hidden until the visitor has added a part. */
export function AccessoryOrderButton({ color = 'inherit' }: { color?: string }) {
  const count = useAccessoryOrderStore((s) => s.items.length);
  if (count === 0) return null;
  const label = `Your order list, ${count} ${count === 1 ? 'part' : 'parts'}`;
  return (
    <IconButton component={RouterLink} to="/accessories/cart" aria-label={label} title={label} sx={{ color }}>
      <Badge badgeContent={count} color="primary">
        <ShoppingCartOutlined />
      </Badge>
    </IconButton>
  );
}